import '../../styles/web-components/size-guide.scss';
import { getElementOrParentByClassName } from '../helpers/utils';
const NUMERIC_REGEX = /\d*\.?\d+/gm;
const INCHES_TO_CM = 2.54;
class SizeGuide extends HTMLElement {
    static get observedAttributes() {
        return ["selected-id", "measurement-system"];
    }
    constructor() {
        super();
        this.addEventListener("click", (e) => {
            const target = e.target;
            if (getElementOrParentByClassName(target, 'size-guide__size-button')) {
                // eslint-disable-next-line wc/no-constructor-attributes
                this.setAttribute("selected-id", target.dataset.id);
            }
        });
        this.addEventListener('change', (e) => {
            const target = e.target;
            // eslint-disable-next-line wc/no-constructor-attributes
            this.setAttribute("measurement-system", target.value);
        });
        // eslint-disable-next-line wc/no-constructor-attributes
        const tds = this.querySelectorAll('td');
        tds.forEach((td) => {
            const content = td.textContent.trim();
            td.setAttribute('imperial-value', content);
            const metricVal = getMetricValue(content, td.hasAttribute('data-prevent-toggle'));
            td.setAttribute('metric-value', metricVal);
        });
    }
    connectedCallback() {
        const initInput = this.querySelector(`input[value=${this.getAttribute("measurement-system")}]`);
        if (initInput) {
            initInput.checked = true;
        }
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue)
            return;
        switch (name) {
            case 'selected-id':
                this.updateTableDisplay(newValue);
                break;
            case 'measurement-system':
                this.handleMeasurementChange(newValue);
        }
    }
    updateTableDisplay(id) {
        this.querySelectorAll('.size-guide__size-button').forEach(el => {
            if (el.dataset.id === id) {
                el.classList.add('size-guide__size-button--selected');
            }
            else {
                el.classList.remove('size-guide__size-button--selected');
            }
        });
        this.querySelectorAll('.size-guide__table').forEach(el => {
            if (el.dataset.id === id) {
                el.classList.remove('hidden');
            }
            else {
                el.classList.add('hidden');
            }
        });
    }
    handleMeasurementChange(system) {
        console.log("size guide: handle measurement change", system);
        this.querySelectorAll('td').forEach(td => td.textContent = td.getAttribute(`${system}-value`));
    }
}
if (!window.customElements.get("size-guide")) {
    customElements.define("size-guide", SizeGuide);
}
function getMetricValue(content, preventConversion) {
    const metric = preventConversion ? content : content.replace(NUMERIC_REGEX, (numStr) => (+numStr * INCHES_TO_CM).toFixed(1));
    return metric;
}
export const _forTesting = {
    getMetricValue
};
